export default __webpack_public_path__ + "media/images/backgrounds/bg-9-49260eee63284d1f3208c60a34b15e41.jpg";